<template>
  <div>
    <van-cell class="ry-form__address" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span
          style="color: red"
          v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if="isRead">
          {{currentText}}
        </div>
        <template v-if="!isRead">
          <van-field
            :readonly="isReadOnly"
            @change="controlChange"
            placeholder="请选择"
            v-model="content"
            @focus="fieldFocus">
            <template #button>
              <van-icon
                v-if="(current.value.province || current.value.city || current.value.county) && !isReadOnly"
                name="close"
                class="close-btn"
                @click.stop="clearData">
              </van-icon>
            </template>
          </van-field>
          <van-field
            class="ry-form__address-detail"
            v-if="current.detailType === ADDRESS_TYPE__DETAIL"
            type="textarea"
            rows="2"
            :readonly="isReadOnly"
            @change="controlChange"
            v-model="current.value.detailAddress"
            placeholder="请输入详细地址">
          </van-field>
        </template>
      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__address-compact">

      <van-field
        :label="current.title"
        :label-class="{'readonly-field-label': !isRead && isReadOnly}"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div
            v-if="isRead">
            {{currentText}}
          </div>
          <div v-else class="ry-form__address-compact-container">
            <van-field
              class="select-address-input"
              :readonly="isReadOnly"
              @change="controlChange"
              :placeholder="isReadOnly ? '暂无内容' : '请选择'"
              v-model="content"
              @focus="fieldFocus">
              <template #button>
                <van-icon
                  v-if="(current.value.province || current.value.city || current.value.county)  && !isReadOnly"
                  name="close"
                  class="close-btn"
                  @click.stop="clearData">
                </van-icon>
              </template>
            </van-field>
            <van-field
              class="ry-form__address-detail"
              v-if="current.detailType === ADDRESS_TYPE__DETAIL"
              type="textarea"
              rows="2"
              :readonly="isReadOnly"
              @change="controlChange"
              v-model="current.value.detailAddress"
              :placeholder="isReadOnly ? '暂无内容' : '请输入详细地址'">
            </van-field>
          </div>
        </template>
      </van-field>
    </div>

    <van-popup
      v-model="show"
      :style="{ height: '40%' }"
      get-container="body"
      position="bottom">
      <van-picker
        ref="addressPicker"
        show-toolbar
        value-key="label"
        title=""
        @cancel="show = false"
        @confirm="pickerConfirm"
        :columns="columns">
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
  import {current} from './mixin'
  import {ADDRESS_TYPE__CITY, ADDRESS_TYPE__COUNTY, ADDRESS_TYPE__DETAIL, ADDRESS_TYPE__PROVINCE} from '../types'

  export default {
    mixins: [current],
    data() {
      return {
        show: false,
        ADDRESS_TYPE__DETAIL
      }
    },
    computed: {
      columns() {
        switch (this.current.detailType) {
          case ADDRESS_TYPE__DETAIL:
          case ADDRESS_TYPE__COUNTY:
            return this.current.countyOptions
          case ADDRESS_TYPE__CITY:
            return this.current.cityOptions
          case ADDRESS_TYPE__PROVINCE:
            return this.current.provinceOptions
          default:
            return this.current.countyOptions
        }
      },
      content: {
        get() {
          const {province, city, county} = this.current.value
          return [province, city, county].filter(item => item).join('/')
        },
        set() {
        }
      },
      currentText() {
        const value = this.current.value || {}
        if (
          value.province ||
          value.city ||
          value.county ||
          value.detailAddress
        ) {
          return `${value.province} ${value.city} ${value.county}\n${value.detailAddress}`
        } else {
          return '暂无内容'
        }
      }
    },
    methods: {
      fieldFocus(event) {
        if (this.isReadOnly) return
        this.openPicker()
        event.target.blur()
      },
      pickerConfirm(result) {
        if (this.current.detailType === ADDRESS_TYPE__PROVINCE) {
          this.current.value.province = result.label
        } else {
          this.current.value.province = result[0]
          this.current.value.city = result[1] || ''
          this.current.value.county = result[2] || ''
        }
        this.show = false
        this.controlChange()
      },
      openPicker() {
        this.show = true
        this.$nextTick(() => {
          const {province, city, county} = this.current.value
          this.$refs.addressPicker.setValues([province, city, county])
        })
      },
      clearData() {
        this.current.value.county = ''
        this.current.value.city = ''
        this.current.value.province = ''
        this.controlChange()
      }
    },
    components: {},
    watch: {}
  }
</script>


<style lang="less">

</style>
